// Utils
import { formatMessage } from './i18n';
import { COLORS } from './colors';

export const CURRENCY = Object.freeze({
  CAD: 'CAD',
  USD: 'USD',
  MIXED: 'MIXED',
});

const CURRENCY_COLORS = {
  [CURRENCY.CAD]: COLORS.RED,
  [CURRENCY.USD]: COLORS.BLUE,
  [CURRENCY.MIXED]: COLORS.VIOLET,
};

/**
 * Get the color associated with a currency, if any. To be used when elements are colored based
 * on the currency (ie: Currency flags next to portfolio holdings).
 *
 * @param currency Currency to get the color for.
 */
export const getCurrencyColor = (currency: string) => CURRENCY_COLORS[currency as keyof typeof CURRENCY];

/**
 * Convert one of the currencies from the CURRENCY enum to text.
 * @param currency Currency
 */
export const currencyToText = (currency?: string) => {
  if (!currency) {
    return '';
  }

  return currency === CURRENCY.MIXED ? formatMessage('Currencies.Mixed') : currency;
};
